import React from 'react'

import classNames from 'classnames'

import useTracker from 'src/lib/js/hooks/useTracker'
import { TrackingEvents } from 'shared/components/common/tracking/TrackingEvents'
import { t } from 'src/translations'

import Image from 'shared/components/common/Image'
import { Modal, ModalOverlay, useModal } from 'shared/components/common/modal'

import { PwlessAuth } from 'public/components/default_template/online_ordering/account/pwlessAuth/PwlessAuth'
import { AuthenticationSource } from 'public/components/default_template/online_ordering/checkout/checkoutUtils'
import {
  FreeDeliveryCheckoutPrompt,
  useFreeDeliveryCheckout
} from 'public/components/default_template/online_ordering/checkout/useFreeDeliveryCheckout'

export const ToastCheckoutButton = () => {
  const tracker = useTracker()
  const { isOpen, onClose, onOpen } = useModal()
  const freeDelivery = useFreeDeliveryCheckout()

  const showFreeDelivery =
    freeDelivery.prompt === FreeDeliveryCheckoutPrompt.SignIn

  const handleClick = () => {
    onOpen()
    tracker.track(TrackingEvents.STARTED_AUTHENTICATION, {
      source: AuthenticationSource.ExpressCheckoutToastPay
    })
  }

  return (
    <div className='checkoutMode'>
      {/* Signing in is what applies the free delivery offer, so lead with that. */}
      <p
        className={classNames('toastPayHeading', {
          // A sentence rather than the label this slot usually holds.
          freeDeliveryHeading: showFreeDelivery
        })}
      >
        {showFreeDelivery
          ? freeDelivery.message
          : t('checkout-mode-buttons.express-checkout-with')}
      </p>
      <button
        type='button'
        className='toastCheckout toastPayButton'
        onClick={handleClick}
        aria-expanded='false'
        aria-controls='checkoutSection'
        aria-label={t('checkout-mode-buttons.toast-aria-label')}
        data-testid='toastPayButton'
      >
        <div className='text'>
          <Image
            alt=''
            aria-hidden='true'
            src='icons/toast-logo-white-with-text.svg'
          />
        </div>
      </button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay fadeIn fadeOut />
        <PwlessAuth source={AuthenticationSource.ExpressCheckoutToastPay} />
      </Modal>
    </div>
  )
}
